import React from 'react';

const HashIcon = ({ width = 17, height = 17 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 17 17"
    fill="none"
  >
    <g clipPath="url(#clip0_2388_7204)">
      <path
        d="M1.87988 5.27295H15.4799"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.08008 11.6733H14.6801"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6803 1.27295L10.2803 15.6729"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.27988 1.27295L3.87988 15.6729"
        stroke="#333333"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_2388_7204">
        <rect
          width="16"
          height="16"
          fill="white"
          transform="translate(0.280273 0.473145)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default HashIcon;
